import { z } from "zod";

/**
 * Minimal shared schema proving that Zod contracts can be shared across the
 * API and frontends. Real API payloads are added during feature work.
 *
 * Prefer inferring types from Zod instead of writing duplicate manual types:
 *   type HealthResponse = z.infer<typeof HealthResponseSchema>;
 */
export const HealthResponseSchema = z.object({
  status: z.literal("ok"),
  service: z.string(),
});

export type HealthResponse = z.infer<typeof HealthResponseSchema>;

export const DbHealthResponseSchema = z.object({
  status: z.enum(["ok", "degraded"]),
  service: z.string(),
});

export type DbHealthResponse = z.infer<typeof DbHealthResponseSchema>;
